var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _path9, _g4, _path10, _path11, _g5, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 38,
    viewBox: "0 0 128 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1351_3122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 10,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.164 8.8667H10.7593V29.1171H19.164V8.8667Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1351_3122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1351_3122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 10,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.164 8.8667H10.7593V29.1171H19.164V8.8667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1351_3122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7593 8.8667V29.1334L19.164 14.8265L10.7593 8.8667Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1351_3122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 8,
    width: 10,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3255 8.8667H30.9208V29.1171H39.3255V8.8667Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1351_3122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1351_3122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 8,
    width: 10,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3255 8.8667H30.9208V29.1171H39.3255V8.8667Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1351_3122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9208 14.8265L39.3091 29.1334V8.8667L30.9208 14.8265Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1351_3122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 12,
    height: 15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9207 4.82312H19.1639V19H30.9207V4.82312Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1351_3122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1351_3122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 12,
    height: 15
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9207 4.82312H19.1639V19H30.9207V4.82312Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1351_3122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9207 14.8265L25.0342 4.82312L19.1639 14.8265L25.0342 19L30.9207 14.8265Z",
    fill: "#1799D5"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7593 29.1334H39.3091L25.0342 19.0001L10.7593 29.1334Z",
    fill: "#1799D5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1351_3122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 14,
    width: 15,
    height: 16
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3091 14.8265H25.0342V29.1171H39.3091V14.8265Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1351_3122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1351_3122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 14,
    width: 15,
    height: 16
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3091 14.8265H25.0342V29.1171H39.3091V14.8265Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1351_3122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0342 19L39.3091 29.1334L30.9207 14.8265L25.0342 19Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1351_3122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 14,
    width: 16,
    height: 16
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0342 14.8265H10.7593V29.1171H25.0342V14.8265Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1351_3122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1351_3122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 14,
    width: 16,
    height: 16
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0342 14.8265H10.7593V29.1171H25.0342V14.8265Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1351_3122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.164 14.8265L10.7593 29.1334L25.0342 19L19.164 14.8265Z",
    fill: "#1799D5"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3091 31.147H10.7593V33.1769H39.3091V31.147Z",
    fill: "#1799D5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8672 1.65643H50.0685V36.3436H51.8672V1.65643Z",
    fill: "#CBD2DD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6197 23.0923H65.6351L64.1961 27.4282H61.0076L67.0086 10.4906H70.2462L76.2472 27.4282H73.0587L71.6197 23.0923ZM68.6274 13.4299C68.6274 13.4299 68.235 15.1026 67.9079 16.0607L66.3872 20.5915H70.8512L69.3305 16.0607C69.0198 15.1026 68.6601 13.4299 68.6601 13.4299H68.611H68.6274Z",
    fill: "#15284B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8006 10.4906H80.8257V23.1897C80.8257 24.5214 81.2835 24.8624 82.0684 24.8624C82.8533 24.8624 82.5263 24.8462 82.5263 24.8462V27.4932C82.5263 27.4932 82.0684 27.5581 81.5615 27.5581C79.8773 27.5581 77.7843 27.1359 77.7843 23.6444V10.5068L77.8006 10.4906Z",
    fill: "#15284B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7827 10.4906H87.8078V13.1863H84.7827V10.4906ZM84.7827 15.265H87.8405V27.4282H84.7827V15.265Z",
    fill: "#15284B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8364 29.8641C97.7169 29.8641 99.303 29.0846 99.303 26.9086V26.194C99.303 25.9017 99.352 25.5445 99.352 25.5445H99.303C98.5835 26.6162 97.5206 27.1846 95.8855 27.1846C92.3863 27.1846 90.3914 24.3752 90.3914 21.0299C90.3914 17.6846 92.2881 14.9727 95.8201 14.9727C99.352 14.9727 99.4501 16.5154 99.4501 16.5154H99.5155C99.5155 16.5154 99.4992 16.3692 99.4992 16.1744V15.2487H102.361V26.6812C102.361 30.8547 99.0904 32.4299 95.9018 32.4299C92.7133 32.4299 92.7296 32.0077 91.5523 31.3744L92.468 29.0521C92.468 29.0521 94.0051 29.8316 95.8528 29.8316L95.8364 29.8641ZM99.3684 21.0624C99.3684 18.3017 97.9948 17.5547 96.3433 17.5547C94.6918 17.5547 93.4654 18.8863 93.4654 20.9487C93.4654 23.0111 94.5774 24.6513 96.5395 24.6513C98.5017 24.6513 99.3684 23.8231 99.3684 21.0786V21.0624Z",
    fill: "#15284B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.713 15.265H108.64V16.6778C108.64 17.1325 108.591 17.506 108.591 17.506H108.64C109.163 16.4829 110.52 14.9727 112.989 14.9727C115.458 14.9727 117.24 16.3855 117.24 19.6009V27.4282H114.215V20.218C114.215 18.7402 113.839 17.7333 112.27 17.7333C110.7 17.7333 109.441 18.7564 108.983 20.218C108.819 20.7214 108.77 21.2735 108.77 21.8419V27.4282H105.713V15.265Z",
    fill: "#15284B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.47815d67c5af4a0fc8cb41dee71d0022.svg";
export { ForwardRef as ReactComponent };